import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import { getTransactionCurrencyRevaluationDetails } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import { Box, Typography, Button, Grid, Tabs, Tab, CircularProgress } from "@mui/material";
import TabPanel from "../../components/TabPanel";

import { GridComp4 } from "../../components/GridComponents";

import CurrencyRevaluationDetails from "./currency-revaluation/details";
import CurrencyRevaluationCustom from "./currency-revaluation/custom";
import CurrencyRevaluationGlImpact from "./currency-revaluation/gl-impact";

export default function TransactionTypeCurrencyRevaluation() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [linkingDocumentNo, setLinkingDocumentNo] = useState("");
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocCurrencyRevaluationsDetailsData();
    }
  }, []);

  async function getTransactionDocCurrencyRevaluationsDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCurrencyRevaluationDetails(user.token, {
        tranid: params.docNo
      });
      setRowData([data.data.details[0]]);
      setLinkingDocumentNo(data.data.linkingdocumentno);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
    <>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      {/*Primary Information*/}
      {rowData.map((d, i) => (
        <Typography component="h4" fontWeight={500} className="pageTitle" sx={{ mb: 2 }}>
          Currency Revaluation
          <>
            {
              d.account === "83005 Realized Exchange Loss (Gain)" ? (
                <> (Realized Gain/Loss)</>
              ) :
                d.account === "83030 Unrealized Matching Gain/Loss" ? (
                  <> (Base Currency Adjustment)</>
                ) :
                  d.account === "83900 Foreign Exchange Loss (Gain) : Rounding Gain/Loss" ? (
                    <> (Rounding Gain/Loss)</>
                  ) :
                    d.account === "83011 Unrealized Gain/Loss" ? (
                      <> (Unrealized Gain/Loss)</>
                    ) :
                      (<></>)}
          </><br />
          <span className="para-no">{d.tranid} </span>
        </Typography>
      ))}


      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">

                <GridComp4 title={"POSTING PERIOD"} data={d.posting_period} />
                <GridComp4 title={"SUBSIDIARY"} data={d.subsidiary} />
                <GridComp4 title={"TOTAL VARIANCE"} data={d.total_variance} />

                <GridComp4 title={"TRANSACTION NUMBER"} data={d.transaction_number} />
                <GridComp4 title={"MEMO"} data={d.memo} />
                {
                  d.account === "83005 Realized Exchange Loss (Gain)" 
                  && d.account === "83030 Unrealized Matching Gain/Loss" 
                  && d.account === "83011 Unrealized Gain/Loss" ? (
                    <></>
                  ) :
                      d.account === "83900 Foreign Exchange Loss (Gain) : Rounding Gain/Loss" ? (
                        <>{d.linkingorderid === null || d.linkingorderid === "" ? (
                          <></>
                        ) : (
                          <Grid item xs={12} sm={6} md={4} className="m-b-10">
                            <p className="tFormlabel">CREATED FROM</p>
                            <p className="tFormName">
                              {d.linkingfullname} <p className="link-color">#</p>
                              <Link
                                className="link-color"
                                target="_blank"
                                to={
                                  "/transaction-type/" +
                                  `${d.linkingtype}` +
                                  "/" +
                                  `${d.linkingorderid}`
                                }
                              >
                                {linkingDocumentNo}
                              </Link>
                            </p>
                          </Grid>
                        )} </>
                      ) : (<></>)}
                <GridComp4 title={"REF NO."} data={d.ref_no} />
                <GridComp4 title={"CURRENCY"} data={d.currency} />

              </Grid>
            </>
          ))}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">

                <GridComp4 title={"DEPARTMENT"} data={d.department} />
                <GridComp4 title={"OPERATION"} data={d.operation} />
                <GridComp4 title={"BUSINESS UNIT"} data={d.business_unit} />

                <GridComp4 title={"SOLUTION"} data={d.solution} />

              </Grid>
            </>
          ))}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Details" />
            <Tab label="Custom" />
            <Tab label="GL Impact" />
          </Tabs>

          {/* Details */}
          <TabPanel value={tabIndex} index={0}>
            <CurrencyRevaluationDetails rowData={rowData} />
          </TabPanel>
          {/* Details */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={1}>
            <CurrencyRevaluationCustom tabIndexP={tabIndex} />
          </TabPanel>
          {/* Custom */}

          {/* Gl Impact */}
          <TabPanel value={tabIndex} index={2}>
            <CurrencyRevaluationGlImpact tabIndexP={tabIndex} />
          </TabPanel>
          {/* Gl Impact */}
        </Box>
      </Box>
    </>
  );
}
